
import './App.css';
import './mobile.css'

function App() {

  const open_target = (e) => {
    e.preventDefault()

    window.open("https://discord.com/api/oauth2/authorize?client_id=832434374392676414&permissions=2685728832&scope=bot", "_blank")
  }

  const go_to_norxwest = (e) => {
    e.preventDefault()

    window.open("https://norxwestdesigns.ca/", "_blank")
  }

  const open_discord = (e) => {
    e.preventDefault()

    window.open("https://discord.com/", "_blank")
  }

  return (
    <div className="App">
      <nav>
        <div className="start-container">
          <div className="icon-container">
            <img src='https://res.cloudinary.com/drlkgoter/image/upload/v1618605909/Nor.%20X%20west/logo_vnofvh.png' alt="icon" />
          </div>
          <h1>Image Bot</h1>
        </div>
        <div className="end-container">
          <div onClick={open_discord} className="icon-container">
            <svg width="59" height="66" viewBox="0 0 59 66" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M52.0885 0H6.91176C3.10188 0 0 3.0315 0 6.78809V51.3388C0 55.0954 3.10165 58.1269 6.91153 58.1269H45.1435L43.3565 52.0308L47.672 55.952L51.7513 59.6426L59 65.9034V6.78809C59 3.0315 55.8984 0 52.0885 0ZM39.0748 43.0352C39.0748 43.0352 37.8612 41.6181 36.8496 40.3659C41.2663 39.1466 42.952 36.4446 42.952 36.4446C41.5696 37.3344 40.2548 37.9606 39.0748 38.3886C37.3892 39.0808 35.7708 39.5419 34.1864 39.8057C30.9496 40.3988 27.9828 40.2341 25.4544 39.7728C23.5325 39.4101 21.8805 38.883 20.4984 38.3559C19.7228 38.0592 18.88 37.6968 18.0369 37.2355C17.936 37.1695 17.8348 37.1366 17.7336 37.0706C17.6664 37.0377 17.6325 37.0048 17.5988 36.9719C16.992 36.6424 16.6548 36.4117 16.6548 36.4117C16.6548 36.4117 18.2732 39.0479 22.5548 40.2999C21.5435 41.5523 20.296 43.0349 20.296 43.0349C12.8449 42.8043 10.0132 38.0264 10.0132 38.0264C10.0132 27.4159 14.868 18.8154 14.868 18.8154C19.7228 15.2566 24.3416 15.3555 24.3416 15.3555L24.6788 15.751C18.6104 17.4641 15.812 20.0676 15.812 20.0676C15.812 20.0676 16.5536 19.6723 17.8009 19.1121C21.4085 17.5632 24.2744 17.135 25.4544 17.0361C25.6565 17.003 25.8252 16.9701 26.0275 16.9701C28.2868 16.6824 30.5732 16.6604 32.8379 16.9043C36.0405 17.2668 39.4795 18.1894 42.9856 20.0676C42.9856 20.0676 40.3224 17.5963 34.5908 15.8828L35.0628 15.3557C35.0628 15.3557 39.6816 15.2566 44.5365 18.8156C44.5365 18.8156 49.3915 27.4159 49.3915 38.0264C49.3915 38.0264 46.5256 42.8043 39.0748 43.0349V43.0352ZM23.3976 27.6466C21.476 27.6466 19.9591 29.2941 19.9591 31.304C19.9591 33.3142 21.5096 34.9618 23.3976 34.9618C25.3195 34.9618 26.8365 33.3142 26.8365 31.304C26.8704 29.2941 25.3195 27.6466 23.3979 27.6466H23.3976ZM35.7035 27.6466C33.7817 27.6466 32.2645 29.2941 32.2645 31.304C32.2645 33.3142 33.8155 34.9618 35.7035 34.9618C37.6252 34.9618 39.1421 33.3142 39.1421 31.304C39.1421 29.2941 37.6252 27.6466 35.7035 27.6466Z" fill="#7289DA"/>
            </svg>
          </div>
          <div onClick={go_to_norxwest} className="icon-container icon-purple">
            <img src="https://res.cloudinary.com/drlkgoter/image/upload/v1616183903/Nor.%20X%20west/black-white_ncjoco.png" alt="norxwesticon" />
          </div>
        </div>
      </nav>
      <div className="circle-backdrop-1"></div>
      <div className="circle-backdrop-2"></div>

      <div className="content-container">
        <div className="inner-content-1">
          <h2>How To Use</h2>
          <p>Easy, just add it to your server, 
then go into any of your text groups, 
and enter the following commands:</p>
          <p>
          ^search “search value” : where search
value is, just type what you want, 
excluding the quotation marks.
          </p>
          <h2>
          Built With
          </h2>
          <p>
          Python and the power of webscrapping
          </p>
        </div>
        <div className="inner-content-2">
          <div className="image-container">
          <img src="https://res.cloudinary.com/drlkgoter/image/upload/v1618605918/Nor.%20X%20west/Screenshot_2021-04-16_131951_hjlqog.png" alt="bot-preview"/>
          </div>
        </div>

        <button onClick={open_target}>Add To Your Server</button>
      </div>
      <footer>
        <h2>Built By Nor. X West Designs</h2>
      </footer>
    </div>
  );
}

export default App;
